import React, { Component } from 'react'
import { Row, Col, Table, Icon } from 'antd'
import { Link } from 'react-router-dom'

class AdminTemplates extends Component {

    render() {
        const columns = [
        {
            title: 'Ficheiro',
            dataIndex: 'filename',
            key: 'filename'
        },
        {
            title: 'Opções',
            key: 'row_action',
            render: (text, record) => (
                <span>
                    <Link to={'/admin/templates/form/' + record.filename}>
                        <Icon type="edit" style={{color: 'green'}} />
                    </Link>
                </span>
            )
        }]
        this.props.items.map((item) => {
            item.key = item.filename
            return item
        })
        return (
            <Row>
                <Col span={24}>
                    <Table dataSource={this.props.items} columns={columns} />
                </Col>
            </Row>
        )
    }
}

export default AdminTemplates;



// WEBPACK FOOTER //
// ./src/components/AdminTemplates.js